import { Component, OnInit  } from '@angular/core'; //, ViewChild
import { Router, NavigationEnd } from '@angular/router';

// PROVIDER
import {BasicProvider} from './providers/basic/basic';
import {UserProvider} from './providers/user/user';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

    constructor(
      public bp:BasicProvider, 
      public up:UserProvider,
      private router: Router,
    ){
      
      if(localStorage.getItem('isLoggedIn') == 'true'){
        this.up.isLoggedIn = true;
        //console.log('inlogin');
        //console.log(this.up.getData());
        this.up.login(this.up.getData());
      }else{
        //console.log('outlogin');
        this.up.isLoggedIn = false;
        //this.up.tempData = this.up.getData();
        //this.up.sid = this.up.tempData.sid;
        //console.log(this.up.tempData);
      }
    }

    ngOnInit() {
      this.router.events.subscribe((evt) => {
          if (!(evt instanceof NavigationEnd)) {
              return;
          }
          window.scrollTo(0, 0);
      });
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts